import React, { Component, Fragment } from 'react';
import { Card, Tag, Row, Col, Collapse, Avatar } from 'antd';
import { inject, observer } from 'mobx-react/index';
import moment from 'moment-timezone';
import { TradingViewEmail } from './TradingViewEmail';
import { TradingViewApi } from './TradingViewApi';
import { CBSView } from './CBS';
import { MHView } from './MH';
const { Panel } = Collapse;

@inject('store')
@observer
export class SignalsView extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.store.botStore.getSignals();
    }

    render() {
        console.log(this.props.store.botStore.signals);

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={16}>
                        <Card bordered={false} size="small">
                            <Collapse bordered={false} expandIconPosition={'right'}>
                                <Panel
                                    header={
                                        <div>
                                            <Avatar src="/signals/TV.png" />
                                            &nbsp;&nbsp;Trading View (API)
                                        </div>
                                    }
                                    key="1"
                                >
                                    <TradingViewApi />
                                </Panel>
                                <Panel
                                    header={
                                        <div>
                                            <Avatar src="/signals/TV.png" />
                                            &nbsp;&nbsp;Trading View (SMS to Email)
                                        </div>
                                    }
                                    key="2"
                                >
                                    <TradingViewEmail />
                                </Panel>
                                <Panel
                                    header={
                                        <div>
                                            <Avatar src="/signals/cbs.png" />
                                            &nbsp;&nbsp;
                                            {this.props.store.botStore.currentConfiguration
                                                .signal_providers &&
                                            this.props.store.botStore.currentConfiguration
                                                .signal_providers.cbs &&
                                            this.props.store.botStore.currentConfiguration
                                                .signal_providers.cbs.enabled ? (
                                                <Tag color="#72ba79">ENABLED</Tag>
                                            ) : null}
                                            Crypto Base Scanner
                                        </div>
                                    }
                                    key="3"
                                >
                                    <CBSView />
                                </Panel>
                                <Panel
                                    header={
                                        <div>
                                            <Avatar src="/signals/mh.png" />
                                            &nbsp;&nbsp;
                                            {this.props.store.botStore.currentConfiguration
                                                .signal_providers &&
                                            this.props.store.botStore.currentConfiguration
                                                .signal_providers.mh &&
                                            this.props.store.botStore.currentConfiguration
                                                .signal_providers.mh.enabled ? (
                                                <Tag color="#72ba79">ENABLED</Tag>
                                            ) : null}
                                            Mining Hamster
                                        </div>
                                    }
                                    key="4"
                                >
                                    <MHView />
                                </Panel>
                            </Collapse>
                        </Card>
                    </Col>
                    <Col md={8}>
                        <Card title={`Recent Signals`} bordered={false}>
                            {this.props.store.botStore.signals.map((o, i) => {
                                let color = '#3a5b94';
                                if (o.status === 'COMPLETE') color = '#72ba79';
                                if (o.status === 'ERROR') color = '#ba7272';
                                return (
                                    <Card
                                        size="small"
                                        style={{ marginBottom: 10 }}
                                        extra={<Tag color={color}>{o.status}</Tag>}
                                        title={
                                            <span>
                                                {this.renderSource(o.source)}
                                                &nbsp;&nbsp;
                                                {(o.side || '').toUpperCase()}{' '}
                                                {o.symbol || 'No Symbol'}
                                            </span>
                                        }
                                        key={i}
                                    >
                                        {this.renderBody(o)}
                                    </Card>
                                );
                            })}
                        </Card>
                    </Col>
                </Row>
            </Fragment>
        );
    }

    renderBody(o) {
        const timezone = this.props.store.userStore.currentUser.timezone;

        if (o.status === 'ERROR') {
            return (
                <div>
                    <b>Message: </b> {o.message}
                </div>
            );
        }
        return (
            <Fragment>
                {this.renderSignalBody(o)}
                <b>Created: </b>{' '}
                {moment(o.created_at)
                    .tz(timezone)
                    .format('DD/MM/YYYY hh:mm:ss a')}{' '}
                <br />
            </Fragment>
        );
    }

    renderSignalBody(o) {
        if (o.side === 'buy') {
            return (
                <Fragment>
                    <b>Group: </b> {o.group || o.signal_id || 'None'}
                    <br />
                    {o.strategy ? (
                        <span>
                            <b>Strategy: </b>{' '}
                            {this.props.store.strategyStore.getStrategy(o.strategy)
                                ? this.props.store.strategyStore.getStrategy(o.strategy).name
                                : 'Deleted Strategy'}
                            <br />
                        </span>
                    ) : null}
                    {o.price ? (
                        <span>
                            <b>Price: </b> {o.price}
                            <br />
                        </span>
                    ) : null}
                </Fragment>
            );
        }

        return (
            <Fragment>
                <b>Group: </b> {o.group || o.signal_id || 'None'}
                <br />
                {o.order_type ? (
                    <span>
                        <b>Order Type: </b> {o.order_type}
                        <br />
                    </span>
                ) : null}
                <b>Price: </b> {o.price || 'None'}
                <br />
            </Fragment>
        );
    }

    renderSource(source) {
        switch (source) {
            case 'cbs':
            case 'mh':
            case 'TV':
                return (
                    <span>
                        <Avatar src={`/signals/${source}.png`} alt={`${source} logo`} />
                    </span>
                );
            default:
                return <span>Unknown Signal Source</span>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SignalsView/index.js